import Typography from '@mui/material/Typography'
import React from 'react'
import { useTranslation } from 'react-i18next'
import EmptyPage from '../../Elements/EmptyPage'

interface EmptyRegionProps {
  isLoading: boolean
}

const EmptyRegion: React.FC<EmptyRegionProps> = (props) => {
  const { t } = useTranslation()

  return (
    <EmptyPage
      {...props}
      message={
        <Typography variant="subtitle1" component="p">
          {t(
            'Region.EmptyState.Instructions',
            `No Region information available.`
          )}
        </Typography>
      }
    />
  )
}

export default EmptyRegion
